import React, {Component} from 'react'
import i18 from '../../i18'
import NotificationSystem from 'react-notification-system'
import api from '../../source/api'
import Row from './rules/row'
import Loading from '../common/loading'
import Modal from 'react-modal'
import Field from '../common/Field'
import Validator from '../common/Validator'
import {Link} from 'react-router-dom'
import BaseComponent from '../base'
import PATH from '../../config/dev'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
}


class BankRules extends BaseComponent {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            reset: false,
            modalIsOpen: false,
            axiosDone: false,
            rerender: props.rerender,
            company_id: props.company_id,
            company: null,
            rules: [],
            editRule: {},
            fields: {
                rulesFile: {value: '', error: '', role: {required: false}},
                item_name: {value: '', error: '', role: {required: false}},
                invoice_number: {value: '', error: '', role: {required: false}},
                company_name: {value: '', error: '', role: {required: false}},
                announcement: {value: '', error: '', role: {required: false}},
                main_bookkeeping_number: {value: '', error: '', role: {required: false}},
                legal_title: {value: '', error: '', role: {required: false}},
                company_fk_id: {value: '', error: '', role: {required: false}},
                id: {value: '', error: '', role: {required: true}},
                type: {value: '', error: '', role: {required: true}},
            },
        }
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem
        window.scrollTo(0, 0)
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        api.get({url: 'bank/rules/get?company_id=' + this.state.company_id, data: {}}, true).then((response) => {
            this.setState({
                rules: response.data.rules,
                axiosDone: true
            })
        }).catch((error) => {
            this.setState({
                axiosDone: true
            })
        })
    }

    uploadRules = () => {
        let rules = document.querySelector('#rulesFile')

        if (rules.files[0]) {
            let form = new FormData()
            form.append('rules', rules.files[0])
            form.append('company_id', this.props.company_id)
            document.body.classList.add('loading-body')

            api.post({url: 'bank/rule/upload', data: form}, true).then((response) => {
                document.body.classList.remove('loading-body')

                this.setState({
                    rules: response.data.rules
                })

            }).catch((err) => {
                document.body.classList.remove('loading-body')
                this._addNotification('Szabályok feltöltése sikertelen.', 'error', 30)
            })

        }
    }

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        if (nextProps.rerender) {
            api.get({url: 'bank/rules/get?company_id=' + this.state.company_id, data: {}}, true).then((response) => {
                this.setState({
                    rules: response.data.rules,
                    axiosDone: true,
                    reset: false,
                })
            }).catch((error) => {
                console.log(error);
                this.setState({
                    axiosDone: true
                })
            })
            this.setState({
                rerender: nextProps.rerender
            })
        }
    }

    closeModal = () => {
        this.setState({modalIsOpen: false})
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value
        fields[name].error = error
        this.setState({fields: fields})
    }

    onElementChange = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value
        this.setState({fields: fields})
    }

    editRule = (rule) => {
        let fields = this.state.fields;

        fields.item_name.value = rule.item_name ? rule.item_name : ''
        fields.company_fk_id.value = rule.company_fk_id
        fields.company_name.value = rule.company_name ? rule.company_name : ''
        fields.invoice_number.value = rule.invoice_number ? rule.invoice_number : ''
        fields.announcement.value = rule.announcement ? rule.announcement : ''
        fields.main_bookkeeping_number.value = rule.main_bookkeeping_number ? rule.main_bookkeeping_number : ''
        fields.legal_title.value = rule.legal_title ? rule.legal_title : ''
        fields.id.value = rule.id
        fields.type.value = rule.type

        this.setState({
            fields: fields,
            editRule: rule,
            modalIsOpen: true
        })
    }

    updateRule = () => {
        let validator = Validator.validate(this.state.fields)
        this.setState({
            fields: validator.fields,
            error: validator.error
        });

        if (this.state.error) {
            return;
        }

        let postData = {
            item_name: this.state.fields.item_name.value,
            company_name: this.state.fields.company_name.value,
            type: this.state.fields.type.value,
            announcement: this.state.fields.announcement.value,
            invoice_number: this.state.fields.invoice_number.value,
            company_fk_id: this.state.fields.company_fk_id.value,
            main_bookkeeping_number: this.state.fields.main_bookkeeping_number.value,
            legal_title: this.state.fields.legal_title.value,
            id: this.state.fields.id.value,
        }
        api.put({url: 'bank/rule/update?company_id=' + this.state.company_id, data: postData}, true).then((response) => {
            this.setState({
                rules: response.data.rules,
                modalIsOpen: false,
                reset: true
            })
            this._addNotification('Szabály szerkesztése sikeres.', 'success', 10)
        }).catch((err) => {
            this.closeModal()
            if (err.response.data === 'BOOK_KEEPING_NUMBER_TAKEN') {
                this._addNotification('Vevő/szallitora nem lehet szabályt alkotni! Kérem válasszon partnert vagy hagyja, függőn!', 'error', 30)
            } else {
                this._addNotification('Szabály mentése sikertelen.', 'error', 30)
            }
        })
    }

    onRemoveRule = (rule) => {
        if (window.confirm('Biztos törölni szeretné a szabályt?')) {
            api.delete({url: 'bank/rule/delete?id=' + rule.id + '&company_id=' + this.props.company.id}, true).then((response) => {
                this.setState({
                    rules: response.data.rules,
                    modalIsOpen: false,
                    reset: true
                })
                this._addNotification('Szabály törlése sikeres.', 'success', 10)
            }).catch((err) => {
                this.closeModal()
                this._addNotification('Szabály törlése sikertelen.', 'error', 30)
            })
        }
    }

    listInvoices = () => {
        if (this.state.rules.length === 0) {
            let colspan = 8
                + (this.props.company && this.props.company.accountant_program_id === 2 ? 1 : 0);

            return <tr>
                <td colSpan={colspan}>{i18.COMMON._noRulesFound}</td>
            </tr>
        }

        let savedRules = []
        for (let index in this.state.rules) {
            let element = this.state.rules[index]
            savedRules.push(<Row
                _addNotification={(msg, type, time) => this._addNotification(msg, type, time)}
                key={element.id}
                rule={element}
                company={this.props.company}
                onRemoveRule={(rule) => this.onRemoveRule(rule)}
                onEditRule={(rule) => this.editRule(rule)}/>)
        }

        return savedRules
    }

    hideRulesBox = () => {
        this.props.editRules()
    }

    printPage = () => {
        window.print()
    }

    downloadRules = () => {
        document.body.classList.add('loading-body')
        api.get({url: 'bank/rule/generateexcel?company_id=' + this.state.company_id, data: {}}, true).then((response) => {
            let file = response.data.file
            setTimeout(() => {
                document.body.classList.remove('loading-body')
                window.open(PATH.ENDPOINT_BASE_URL + 'bank/rule/downloadrulesexcel'
                    + '?auth_token=' + api.getToken()
                    + '&company_id=' + this.state.company_id
                    + '&name=' + file
                )
            }, 1500)
        }).catch((err) => {
            this._addNotification('Szabályok letöltése sikertelen.', 'error', 30)
        })
    }


    deleteAllRules = () => {
        if (window.confirm('Biztos törölni szeretné az összes szabályt?')) {
            api.get({url: 'bank/rules/deleteall?company_id=' + this.state.company_id, data: {}}, true).then((response) => {
                this.setState({
                    rules: [],
                    reset: true
                })
            }).catch((err) => {
                this.closeModal()
                this._addNotification('Szabályok törlése sikertelen.', 'error', 30)
            })
        }
    }

    render() {
        if (!this.state.axiosDone && !this.state.rules.length) {
            return <div className='container text-center'><Loading/></div>
        }
        return (
            <section id='customer-rules'>
                <div className='header'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h1>
                                    <a onClick={() => this.hideRulesBox()} className='choose-btn'>{i18.BUTTONS._back}</a> {i18.CUSTOMER._rulesTitle}
                                </h1>
                            </div>
                            <div className='col-12'>
                                <p>
                                    {i18.CUSTOMER._rulesDescription}
                                </p>
                                <a className='link-color' onClick={() => this.printPage()}><i className="fa fa-print" aria-hidden="true"></i>&nbsp;{i18.COMMON._printRules}</a>
                                &nbsp;&nbsp;&nbsp;&nbsp;<a className='link-color' onClick={() => this.deleteAllRules()}><i className="fa fa-trash-o" aria-hidden="true"></i>&nbsp;{i18.COMMON._deleteAllRules}</a>
                                &nbsp;&nbsp;&nbsp;&nbsp;<a className='link-color' onClick={() => this.downloadRules()}><i className="fa fa-download" aria-hidden="true"></i>&nbsp;{i18.COMMON._downloadRules}</a>
                            </div>
                            <div className='col-12 margin-top-10'>

                                <div className='row'>
                                    <div className='col-4'>

                                        <Field
                                            type='file'
                                            id='rulesFile'
                                            name='rulesFile'
                                            label={i18.COMMON._uploadRules}
                                            fileUploadEndpoint=''
                                            classLabel='control-label'
                                            classInput='file-input'
                                            setValue={this.setValue.bind(this)}
                                            state={this.state}
                                            style={{width: '100%'}}
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <br/>
                                        <a onClick={() => this.uploadRules()} className='choose-btn-thin'>{i18.BUTTONS._uploadRules}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='body'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <table className='table table-striped  table-aibook-no-border'>
                                    <thead>
                                    <tr>
                                        <th>{i18.BANK._typeOfTraffic}</th>
                                        <th>{i18.BANK._invoiceNumber}</th>
                                        <th>{i18.BANK._companyName}</th>
                                        <th>{i18.BANK._announcement}</th>
                                        <th>{i18.BANK._mainBookNumber}</th>
                                        {this.props.company && this.props.company.accountant_program_id === 2
                                            ? <th>{i18.BANK._legalTitle}</th>
                                            : null
                                        }
                                        <th>{i18.COMMON._typeOfRule}</th>
                                        <th>Módosítva</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.listInvoices()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={() => this.closeModal()}
                    style={customStyles}
                    contentLabel='Szabály szerkesztése'>
                    <h4>{i18.COMMON._editRuleText}</h4>
                    <div className='modal-body'>
                        <Field
                            type='text' id='item_name' name='item_name'
                            label={i18.CUSTOMER._typeOfTraffic} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='invoice_number' name='invoice_number'
                            label={i18.CUSTOMER._invoiceNumber} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='company_name' name='company_name'
                            label={i18.CUSTOMER._companyName} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='announcement' name='announcement'
                            label={i18.CUSTOMER._announcement} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='main_bookkeeping_number' name='main_bookkeeping_number'
                            label={i18.CUSTOMER._mainBookNumber} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>

                        {this.props.company && this.props.company.accountant_program_id === 2
                            ? <div>
                                <label htmlFor="legal_title" className="margin-top-10 margin-bottom-2 control-label">{i18.CUSTOMER._legalTitle}</label>
                                <select value={this.state.fields.legal_title.value}
                                        name='legal_title'
                                        id='legal_title'
                                        onChange={(codeevent) => this.onElementChange(codeevent)}
                                        className='minimal-100  form-control'>
                                    <option value=""></option>
                                    <option value="B03">B03 - Kölcsönfelvétel</option>
                                    <option value="B04">B04 - Tagi kölcsön felvétele</option>
                                    <option value="B05">B05 - Tartós alapítói vagyon rendelkezésre bocsátása</option>
                                    <option value="B06">B06 - Folyósított kölcsön és kamata</option>
                                    <option value="B13">B13 - Kapott osztalék</option>
                                    <option value="B99">B99 - Pénzbevétel egyéb forrásból</option>
                                    <option value="K03">K03 - Kölcsön visszafizetése</option>
                                    <option value="K04">K04 - Tagi kölcsön visszafizetése</option>
                                    <option value="K05">K05 - Tartós alapítói vagyon visszafizetése</option>
                                    <option value="K06">K06 - Kölcsön folyósítása</option>
                                    <option value="K07">K07 - Munkabér</option>
                                    <option value="K08">K08 - Foglalkoztatás terhei</option>
                                    <option value="K09">K09 - ÁFA</option>
                                    <option value="K10">K10 - Nyereséget terhelő adók</option>
                                    <option value="K11">K11 - Helyi adók</option>
                                    <option value="K12">K12 - Egyéb adók</option>
                                    <option value="K13">K13 - Fizetett osztalék</option>
                                    <option value="K99">K99 - Egyéb pénzkiadás</option>
                                    <option value="T01">T01 - Technikai</option>
                                </select>
                            </div>
                            : null
                        }

                        <label htmlFor="type" className="margin-top-10 margin-bottom-2 control-label">{i18.COMMON._typeOfRule}</label>
                        <select value={this.state.fields.type.value}
                                id='type'
                                name='type'
                                onChange={(codeevent) => this.onElementChange(codeevent)}
                                className='minimal-100  form-control'>
                            <option value="temporarily">{i18.COMMON._temporarirlyRule}</option>
                            <option value="final">{i18.COMMON._finalRule}</option>
                        </select>

                    </div>
                    <div className='modal-footer text-center'>
                        <a onClick={() => this.updateRule()} className='btn btn-success btn-sm'>{i18.COMMON._save}</a>
                        &nbsp;&nbsp;&nbsp;
                        <a onClick={() => this.closeModal()} className='btn btn-danger btn-sm'>{i18.COMMON._close}</a>
                    </div>

                </Modal>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default BankRules


// WEBPACK FOOTER //
// ./src/components/bank/bankrules.js